import React from 'react';
import Logo from '../common/Logo';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTwitter, FiFacebook, FiLinkedin, FiGithub } = FiIcons;

const socialLinks = [
  { icon: FiTwitter, href: '#' },
  { icon: FiFacebook, href: '#' },
  { icon: FiLinkedin, href: '#' },
  { icon: FiGithub, href: '#' },
];

const footerLinks = {
  Solutions: ['Marketing', 'Analytics', 'Commerce', 'Insights'],
  Support: ['Pricing', 'Documentation', 'Guides', 'API Status'],
  Company: ['About', 'Blog', 'Jobs', 'Press', 'Partners'],
  Legal: ['Claim', 'Privacy', 'Terms'],
};

const Footer = () => {
  return (
    <footer className="bg-gray-800 border-t border-gray-700">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="space-y-8 xl:col-span-1">
            <Logo />
            <p className="text-gray-400 text-base">
              The leading referral management platform.
            </p>
            <div className="flex space-x-6">
              {socialLinks.map((item, i) => (
                <a key={i} href={item.href} className="text-gray-400 hover:text-brand-secondary">
                  <span className="sr-only">{item.icon.name}</span>
                  <SafeIcon icon={item.icon} className="h-6 w-6" />
                </a>
              ))}
            </div>
          </div>
          <div className="mt-12 grid grid-cols-2 gap-8 xl:mt-0 xl:col-span-2">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold text-gray-200 tracking-wider uppercase">Solutions</h3>
                <ul className="mt-4 space-y-4">
                  {footerLinks.Solutions.map((item) => (
                    <li key={item}>
                      <a href="#" className="text-base text-gray-400 hover:text-white">
                        {item}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h3 className="text-sm font-semibold text-gray-200 tracking-wider uppercase">Support</h3>
                <ul className="mt-4 space-y-4">
                  {footerLinks.Support.map((item) => (
                    <li key={item}>
                      <a href="#" className="text-base text-gray-400 hover:text-white">
                        {item}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold text-gray-200 tracking-wider uppercase">Company</h3>
                <ul className="mt-4 space-y-4">
                  {footerLinks.Company.map((item) => (
                    <li key={item}>
                      <a href="#" className="text-base text-gray-400 hover:text-white">
                        {item}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h3 className="text-sm font-semibold text-gray-200 tracking-wider uppercase">Legal</h3>
                <ul className="mt-4 space-y-4">
                  {footerLinks.Legal.map((item) => (
                    <li key={item}>
                      <a href="#" className="text-base text-gray-400 hover:text-white">
                        {item}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t border-gray-700 pt-8">
          <p className="text-base text-gray-400 xl:text-center">&copy; {new Date().getFullYear()} ReferBridge, Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;